document.addEventListener('DOMContentLoaded', function () {

  function triggerAnimation(el) {
    if (!el) return;
    el.classList.remove('animate');
    void el.offsetWidth;
    el.classList.add('animate');
    el.addEventListener('animationend', () => el.classList.remove('animate'), { once: true });
  }

  // Aktualizacja licznika koszyka
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        const cartIcon = document.querySelector('[class*="ai-header-cart-count"]');
        if (cartIcon) {
          cartIcon.textContent = count;
          triggerAnimation(cartIcon);
        }
      });
  }

  // Animacja przycisków + i -
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity-plus, .quantity-minus');
    if (!btn) return;
    triggerAnimation(btn);
    const input = btn.closest('quantity-input, .quantity__wrapper, .quantity')
      ?.querySelector('input');
    if (input) triggerAnimation(input);
  }, true);

  // Przechwycenie dodawania do koszyka
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    if (url.includes('/cart/add')) {
      return originalFetch.apply(this, args).then(function (response) {
        if (response.ok) {
          updateCartCount();
        }
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };

});
